// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uidebug {\n  border-color: #4ade80;\n  border-width: 2;\n  border-style: solid;\n  font-size: 11px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  padding: 0 4px 4px;\n  border-radius: 4px;\n}\n.uidebug.err {\n  border-color: #f87171;\n}\n\n.uidebug-label {\n  margin: 0 0 4px -4px;\n  padding: 1px 2px;\n  display: inline-block;\n  background-color: #4ade80;\n}\n.uidebug-label.err {\n  background-color: #f87171;\n}\n", ""]);
// Exports
module.exports = exports;
